<script>
import * as models from './models'
import api from '@utils/api'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'ItemEdit',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      item: {
        name: null,
        description: null,
        goods: null,
        temperature: null,
        density: null,
        shortName: null,
      },
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
        empty: [() => true],
      },
    }
  },
  computed: {
    modelName() {
      return this.$route.params.dictionary
    },
    model() {
      return models[this.modelName]
    },
    fields() {
      return this.model.filter(elem => elem.type !== 'id')
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  watch: {
    currentItem: {
      handler(next) {
        Object.assign(this.item, next)
      },
      deep: true,
    },
  },
  methods: {
    getDictionary(value) {
      return this.$store.getters['data/getDictionary'](value)
    },
    closeModal() {
      this.$emit('close-modal')
      this.$refs.formNew.reset()
    },
    submit() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        const item = {}
        for (const field of this.model) {
          item[field.code] = this.item[field.code]
        }
        api.updateItem(this.modelName, item).then(response => {
          this.$emit('item-updated')
          this.$emit('close-modal')
          this.loading = false
          this.$refs.formNew.reset()
          this.$store.dispatch('data/updateDictionary', this.modelName)
        })
      }
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__update') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="text-xs-center">
              <v-form ref="formNew" v-model="valid" lazy-validation>
                <template v-for="field in fields">
                  <v-text-field
                    v-if="field.type === 'input'"
                    :key="field.code"
                    :name="field.code"
                    :label="$t(`label__${field.name}`)"
                    :readonly="!userAllowedToUpdate"
                    v-model="item[field.code]"
                    :rules="field.required ? rules.isRequired : rules.empty"
                    :required="field.required"
                    :type="field.isNumber ? 'number' : 'text'"
                    autocomplete="off"
                  />
                  <v-select
                    v-if="field.type === 'select'"
                    :key="field.code"
                    :items="getDictionary(field.dictionary)"
                    :label="$t(`label__${field.name}`)"
                    :readonly="!userAllowedToUpdate"
                    v-model="item[field.code]"
                    :item-text="field.itemText"
                    :item-value="field.itemValue"
                    :rules="field.required ? rules.isRequired : rules.empty"
                    :required="field.required"
                    autocomplete
                  />
                </template>
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="loading" color="secondary" @click="closeModal">{{
          $t('buttons__close')
        }}</v-btn>
        <v-btn
          v-if="userAllowedToUpdate"
          :disabled="loading"
          :loading="loading"
          color="success"
          @click="submit"
          >{{ $t('buttons__update') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
